import { formatPhoneNumber } from "utils/common";

import { PREFERRED_CHANNEL_TYPES } from "../../../../constants/suno-comms";
import { LEAD_CONTACT_OPTIONS } from "../merge-tags-options/lead-contact.utils";
import type { MergeTagsReplaceHandler } from "./merge-tags-values";

export const LEAD_CONTACT_VALUES: MergeTagsReplaceHandler = {
  [LEAD_CONTACT_OPTIONS.LEAD_FIRST_NAME]: ({ extraData }) => {
    return extraData?.leadContact?.first_name ?? "";
  },
  [LEAD_CONTACT_OPTIONS.LEAD_LAST_NAME]: ({ extraData }) => {
    return extraData?.leadContact?.last_name ?? "";
  },
  [LEAD_CONTACT_OPTIONS.LEAD_FULL_NAME]: ({ extraData }) => {
    const contact = extraData?.leadContact;
    return [contact?.first_name, contact?.last_name].filter(Boolean).join(" ");
  },
  [LEAD_CONTACT_OPTIONS.LEAD_PHONE]: ({ extraData }) => {
    const phone = extraData?.leadContact?.active_phone?.phone_number;
    return phone ? formatPhoneNumber(phone) : "";
  },
  [LEAD_CONTACT_OPTIONS.LEAD_EMAIL]: ({ extraData }) => {
    return extraData?.leadContact?.active_email?.email ?? "";
  },
  [LEAD_CONTACT_OPTIONS.LEAD_SERVICE_INTERESTS]: ({ extraData }) => {
    return extraData?.leadContact?.service_interests
      ?.map((item: any) => item.name)
      ?.join(", ");
  },
  [LEAD_CONTACT_OPTIONS.LEAD_LOCATION_NAME]: ({ extraData }) => {
    return extraData?.leadContact?.location?.name ?? "";
  },
  [LEAD_CONTACT_OPTIONS.LEAD_LOCATION_PHONE]: ({ extraData }) => {
    const phone = extraData?.leadContact?.location?.voip_number;
    return phone ? formatPhoneNumber(phone) : "";
  },
  [LEAD_CONTACT_OPTIONS.LEAD_PREFERRED_CHANNEL]: ({ extraData }) => {
    return PREFERRED_CHANNEL_TYPES.getFromCode(
      extraData?.leadContact?.preferred_channel
    );
  }
};
